import { useState } from "react";
import { BRAND, LINE, WHITE, TEXT, SURFACE, MUTED } from "./constants";
import { useIsMobile } from "./lib/responsive";

const AddReferenceInline = ({ candidate, lang, onSave }) => {
  const [open, setOpen] = useState(false);
  const isMobile = useIsMobile();
  const [form, setForm] = useState({refName:"",refCompany:"",refRole:"",refRelation:"",refStrengths:"",refWeaknesses:"",refLeadership:"",refCulture:"",refSituation:"",refComments:""});
  const set=(k,v)=>setForm(f=>({...f,[k]:v}));
  const inp={width:"100%",boxSizing:"border-box",padding:"8px 10px",border:`1.5px solid ${LINE}`,borderRadius: 8,fontSize: 12,outline:"none",fontFamily:"inherit"};
  const save=()=>{
    if(!form.refName.trim())return;
    const idx=(candidate.refsData||[]).length+1;
    const nr={title:idx+". "+form.refName+" — "+form.refRole+" at "+form.refCompany,subtitle:form.refRelation,items:[["Main strengths",form.refStrengths],["Areas for improvement",form.refWeaknesses],["Leadership style",form.refLeadership],["Culture fit",form.refCulture],["Challenging situation",form.refSituation],["Additional comments",form.refComments]].filter(([,v])=>v)};
    onSave(nr);setForm({refName:"",refCompany:"",refRole:"",refRelation:"",refStrengths:"",refWeaknesses:"",refLeadership:"",refCulture:"",refSituation:"",refComments:""});setOpen(false);
  };
  // Móvil: media fila junto a "Editar preguntas"; abierto, todo el ancho
  return (
    <div style={isMobile ? { flex: open ? "1 1 100%" : "1 1 0", minWidth: 0, order: 1 } : undefined}>
      <button onClick={()=>setOpen(v=>!v)}
        style={{
          background: WHITE,
          color: open ? BRAND : TEXT,
          border: "1.5px solid " + (open ? BRAND : LINE),
          borderRadius: 8,
          padding: "9px 16px",
          fontWeight: 700,
          fontSize: 13,
          cursor: "pointer",
          fontFamily: "inherit",
          display: "inline-flex",
          alignItems: "center",
          gap: 8,
          height: 36,
          boxSizing: "border-box",
          lineHeight: 1,
          ...(isMobile ? { width: "100%", height: 40, justifyContent: "center", padding: "0 10px", whiteSpace: "nowrap" } : null),
        }}
        onMouseEnter={e => { if (!open) e.currentTarget.style.borderColor = BRAND; }}
        onMouseLeave={e => { if (!open) e.currentTarget.style.borderColor = LINE; }}>
        {open ? (lang === "es" ? "Cancelar" : "Cancel") : ("+ " + (lang === "es" ? "Añadir manualmente" : "Add manually"))}
      </button>
      {open&&(<div style={{marginTop:16,background:SURFACE,border:`1.5px solid ${LINE}`,borderRadius:12,padding:"18px 20px"}}>
        <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:10,marginBottom:12}}>
          {[{k:"refName",l:lang==="es"?"Nombre *":"Referee name *"},{k:"refCompany",l:"Company"},{k:"refRole",l:"Role"},{k:"refRelation",l:lang==="es"?"Relación":"Relationship"}].map(({k,l})=>(
            <div key={k}><label style={{fontSize: 11,color:MUTED,display:"block",marginBottom:3}}>{l}</label>
            <input value={form[k]} onChange={e=>set(k,e.target.value)} style={inp} onFocus={e=>e.target.style.borderColor=BRAND} onBlur={e=>e.target.style.borderColor={LINE}}/></div>
          ))}
        </div>
        {[{k:"refStrengths",l:"Main strengths"},{k:"refWeaknesses",l:"Areas for improvement"},{k:"refLeadership",l:"Leadership style"},{k:"refCulture",l:"Culture fit"},{k:"refSituation",l:"Challenging situation"},{k:"refComments",l:"Additional comments"}].map(({k,l})=>(
          <div key={k} style={{marginBottom:10}}><label style={{fontSize: 11,color:MUTED,display:"block",marginBottom:3}}>{l}</label>
          <textarea value={form[k]} onChange={e=>set(k,e.target.value)} rows={2} style={{...inp,resize:"vertical"}} onFocus={e=>e.target.style.borderColor=BRAND} onBlur={e=>e.target.style.borderColor={LINE}}/></div>
        ))}
        <div style={{display:"flex",justifyContent:"flex-end",marginTop:8}}>
          <button onClick={save} disabled={!form.refName.trim()} style={{background:!form.refName.trim()?LINE:BRAND,color:!form.refName.trim()?MUTED:WHITE,border:"none",borderRadius:8,padding:"9px 20px",fontWeight:700,fontSize: 13,cursor:!form.refName.trim()?"not-allowed":"pointer"}}>
            {"✓ "+(lang==="es"?"Guardar referencia":"Save reference")}
          </button>
        </div>
      </div>)}
    </div>
  );
};





export default AddReferenceInline;
